import { render, staticRenderFns } from "./productImages.vue?vue&type=template&id=fd153e54&scoped=true"
import script from "./productImages.vue?vue&type=script&lang=js"
export * from "./productImages.vue?vue&type=script&lang=js"
import style0 from "./productImages.vue?vue&type=style&index=0&id=fd153e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd153e54",
  null
  
)

export default component.exports